import React from 'react';

import Report360 from 'components/360';

export default function index({ match }) {
  const { id } = match.params;

  return <Report360 surveyContainerId={id} />;
}
